import userMapping from './user-mapping.json';
import {
  getAllClientsProgram,
  addFinalUserRecords,
  deleteAllPendingRecords,
  updateExistingUserInfo,
  updateBatchUsersWithPoints,
  getUserLastLockDate,
} from '../../../../api/batch-user-upload-tool';
import moment from 'moment';

getAllClientsProgram({
  clientId: 0,
  status: 'Active',
}).then((response) => {
  clientPrograms = response;
});

let orders;
let returns;
let staff;
let terminated;
let active;
let users;
let clientPrograms;
let rehireUserNamesTerminationDateMap = new Map();
let lockedUserDateMap = new Map();

function handleUsersReportFileSelect() {
  orders = undefined;
  returns = undefined;

  if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
    alert('The File APIs are not fully supported in this browser.');
    return;
  }

  const input = document.getElementById('ordersReport');
  if (!input) {
    alert("Um, couldn't find the ordersReport element.");
  } else if (!input.files) {
    alert("This browser doesn't seem to support the `files` property of file inputs.");
  } else if (!input.files[0]) {
    alert("Please select a file before clicking 'Load'");
  } else {
    const file = input.files[0];
    const fr = new FileReader();
    fr.onload = readUsers;
    fr.readAsBinaryString(file);
  }
}

function readUsers() {
  const data = this.result;
  let workbook;
  try {
    workbook = XLSX.read(data, { type: 'binary' });
  } catch (e) {
    alert(e.message);
    return;
  }

  // TODO receive "PRU" from outside

  let rows = XLSX.utils.sheet_to_json(workbook.Sheets['Sheet1'], { raw: false });
  if (rows.length === 0) {
    alert('The File doesn\'t seem have a "Sheet1" sheet.');
    return;
  } else if (rows[0]['Username'] === undefined) {
    alert('The "Sheet1" sheet doesn\'t seem have a "UserName" column.');
    return;
  } else if (rows[0]['FirstName'] === undefined) {
    alert('The "Sheet1" sheet doesn\'t seem have a "FirstName" column.');
    return;
  } else if (rows[0]['LastName'] === undefined) {
    alert('The "Sheet1" sheet doesn\'t seem have a "LAST NAME" column.');
    return;
  }
  // console.log(rows);
  users = rows;
}

function handleHRStaffingFileSelect() {
  staff = undefined;
  if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
    alert('The File APIs are not fully supported in this browser.');
    return;
  }

  const input = document.getElementById('hrStaffing');
  if (!input) {
    alert("Um, couldn't find the hrStaffing element.");
  } else if (!input.files) {
    alert("This browser doesn't seem to support the `files` property of file inputs.");
  } else if (!input.files[0]) {
    alert("Please select a file before clicking 'Load'");
  }
  else {
    const file = input.files[0];
    const fr = new FileReader();
    fr.onload = readStaff;
    fr.readAsBinaryString(file);
  }
}

function readStaff() {
  const data = this.result;
  let workbook;
  try {
    workbook = XLSX.read(data, { type: 'binary' });
  } catch (e) {
    alert(e.message);
    return;
  }
  let activeEmployeeRows = XLSX.utils.sheet_to_json(workbook.Sheets['Active'], { raw: false });
  let termEmployeeRows = XLSX.utils.sheet_to_json(workbook.Sheets['Terms'], { raw: false });


  if (!termEmployeeRows || termEmployeeRows.length == 0) {
    alert('Could not find the "Terms" worksheet. Please make sure a workseeht called "Terms" is in the HR staffing file.')
  }

  // Validate Required Headers are present in both sheets
  let errors = ValidateHRStaffingFileHeaders(activeEmployeeRows, termEmployeeRows)

  if (errors && errors.length > 0) {
    alert(errors.join("\n"))
  }

  let deleteletedUsers = [];
  const termEmployeeMap = new Map();
  if (termEmployeeRows.length > 0 && termEmployeeRows[0]['TERMINATION_DATE']) {
    termEmployeeRows.forEach((row) => {
      if (row['TERMINATION_DATE'] && moment(new Date()).diff(moment(new Date(row['TERMINATION_DATE'])), 'days') > 30) {
        deleteletedUsers.push(row['N#']);
      }
      termEmployeeMap.set(row['N#'], row['TERMINATION_DATE']);
    });
  }
  if (activeEmployeeRows.length > 0 && activeEmployeeRows[0]['N#']) {
    activeEmployeeRows.forEach((row) => {
      if (deleteletedUsers.indexOf(row['N#']) >= 0) {
        deleteletedUsers = deleteletedUsers.filter((user) => user !== row['N#']);
      }
      if (termEmployeeMap.has(row['N#'])) {
        rehireUserNamesTerminationDateMap.set(row['N#'], termEmployeeMap.get(row['N#']));
      }
    });
  } else {
    rehireUserNamesTerminationDateMap = new Map();
  }

  terminated = deleteletedUsers;
  active = activeEmployeeRows.map((row) => ({
    ...row,
    ['DEPT_CODE']: String(row['DEPT_CODE'])
      .padStart(5, '0')
      .toString(),
  }));
}

function ValidateHRStaffingFileHeaders(activeEmployeeRows, termEmployeeRows) {

  const requiredActiveEmployeeHeaders = ["N#", "EMPLOYEE_FIRST_NAME", "EMPLOYEE_LAST_NAME", "EMPLOYEE_NUMBER", "EMPLOYEE_EMAIL_ADDRESS"]
  const requiredTermsEmployeeHeaders = ['N#', 'EMPLOYEE_FIRST_NAME', 'EMPLOYEE_LAST_NAME', 'TERMINATION_DATE']
  let errors = []

  // Validate Active Employee Sheet
  for (let header of requiredActiveEmployeeHeaders) {
    if (!activeEmployeeRows[0][header]) {
      errors.push(`Active Employee Sheet Missing ${header} Header`)
    }
  }
  // Valiate Terminated Employee Sheet
  if (!termEmployeeRows) {
    console.log("terms sheet not provided, nothing to do here")
    return;
  }

  for (let header of requiredTermsEmployeeHeaders) {
    if (!termEmployeeRows[0][header]) {
      errors.push(`Terms Employee Sheet Missing ${header} Header`)
    }
  }

  return errors

}

async function updateUsers() {
  // console.log('updateUsers', terminated);
  const activeLockedUserName = [];
  try {
    if (users === undefined) {
      alert('Please provide an "Users report" spreadsheet');
      return;
    } else if (active === undefined) {
      alert('Please provide a "HR Staffing" spreadsheet');
      return;
    }
    let filterdUsers;
    if (terminated !== undefined) {
      filterdUsers = await users.reduce((currentValue, user) => {
        if (terminated.indexOf(user['Username']) != -1 && user.Disabled != 1) {
          user.Program_id = '';
          user.Program_name = '';
          user.Disabled = 1;
          user.points *= -1;
          user.Transaction_comments = 'Term 30+ days per HR Staffing';
          return [...currentValue, user];
        }
        if (terminated.indexOf(user['Username']) === -1 && user.Disabled === '1') {
          activeLockedUserName.push(user.Username);
        }
        return currentValue;
      }, []);
    }
    let incompleteUsers = active.filter(
      (user) =>
        !user['N#'] ||
        !user['EMPLOYEE_FIRST_NAME'] ||
        !(user['EMPLOYEE_EMAIL_ADDRESS'] || user['EMPLOYEE_EMAIL_ADDRESS_2']) ||
        !user.DEPT_CODE ||
        !user.JOB_CODE
    );
    const lockedUserDate =
      (await getUserLastLockDate(
        activeLockedUserName.reduce((currentValue, user) => {
          if (users.find((u) => u.Username === user)) {
            return [...currentValue, { user: Number(users.find((u) => u.Username === user).UserId) }];
          }
          return currentValue;
        }, [])
      )) ?? [];
    lockedUserDate.forEach((user) => {
      lockedUserDateMap.set(user.userid, user.last_lock_date);
    });
    return { incompleteUsers, filterdUsers };
  } catch (e) {
    console.log(e);
  }
}

let total = 0;
async function processUserAdds(filterdUsers, incompleteUsers) {
  try {
    const filterdActiveUsers = active.filter(
      (user) =>
        user['N#'] &&
        user['EMPLOYEE_FIRST_NAME'] &&
        (user['EMPLOYEE_EMAIL_ADDRESS'] || user['EMPLOYEE_EMAIL_ADDRESS_2']) &&
        user.DEPT_CODE &&
        user.JOB_CODE
    );
    incompleteUsers = incompleteUsers.filter(
      (user) =>
        user['N#'] &&
        user['EMPLOYEE_FIRST_NAME'] &&
        (user['EMPLOYEE_EMAIL_ADDRESS'] || user['EMPLOYEE_EMAIL_ADDRESS_2']) &&
        user.DEPT_CODE &&
        user.JOB_CODE
    );
    filterdActiveUsers.push(...incompleteUsers);
    filterdActiveUsers.forEach((user) => {
      const userClient = clientPrograms.find(
        (client) => client.clientId === userMapping.find((m) => m.DEPT_CODE === user.DEPT_CODE && m.JOB_CODE === user.JOB_CODE)?.['Group (Divvy)']
      );
      if (!users.some((u) => u.Username === user['N#']) && userClient) {
        const userClient = clientPrograms.find(
          (client) => client.clientId === userMapping.find((m) => m.DEPT_CODE === user.DEPT_CODE && m.JOB_CODE === user.JOB_CODE)['Group (Divvy)']
        );
        filterdUsers.push({
          UserId: '',
          Username: user['N#'],
          points: 0.0,
          SingleItem: 0,
          Administrator: 0,
          Disabled: 0,
          Code: '',
          Program_id: '',
          Program_name: '',
          SSN: '',
          FirstName: user.EMPLOYEE_FIRST_NAME,
          LastName: user.EMPLOYEE_LAST_NAME,
          MiddleInitial: user.EMPLOYEE_MIDDLE_NAME,
          Address1: '',
          Address2: '',
          City: '',
          State: '',
          zip: '',
          Dayphone: '',
          eveningphone: '',
          email: user.EMPLOYEE_EMAIL_ADDRESS ?? user.EMPLOYEE_EMAIL_ADDRESS2,
          Company_name: userClient.clientName,
          company_id: userClient.clientId,
          Transaction_comments: '',
          Email_msg: '',
          email_subject: '',
          Joining_Date: '',
          Birthday: '',
          birthyear: '',
        });
      } else if (users.some((u) => u.Username === user['N#']) && userClient) {
        const _user = users.find((u) => u.Username === user['N#']);
        if (rehireUserNamesTerminationDateMap.has(_user.Username)) {
          const lastLockDate = rehireUserNamesTerminationDateMap.get(_user.Username);
          _user.Disabled = 0;
          _user.Company_name = userClient.clientName;
          _user.company_id = userClient.clientId;
          if (moment().diff(moment(lastLockDate), 'days') > 30) {
            _user.points *= -1;
          } else {
            _user.points = 0;
          }
          filterdUsers.push(_user);
        } else if (_user.Disabled === '1' && lockedUserDateMap.has(Number(_user.UserId))) {
          _user.Disabled = 0;
          _user.Company_name = userClient.clientName;
          _user.company_id = userClient.clientId;
          if (moment().diff(moment(lockedUserDateMap.get(Number(_user.UserId))), 'days') > 30) {
            _user.points *= -1;
          } else {
            _user.points = 0;
          }
          filterdUsers.push(_user);
        }
      }
    });
  } catch (e) {
    console.log(e);
  }
}

export async function deleteAllRecords() {
  try {
    await deleteAllPendingRecords();
  } catch (e) {
    console.log(e);
  }
}

export async function finalize() {
  try {
    for (let i = 0; i < total; i++) {
      try {
        await addFinalUserRecords();
      } catch (e) { }
    }
    await updateExistingUserInfo();

    await updateBatchUsersWithPoints();

    users = undefined;
    active = undefined;
    terminated = undefined;
    clientPrograms = undefined;
    staff = undefined;
    total = 0;
    rehireUserNamesTerminationDateMap = new Map();
    return;
  } catch (e) {
    console.log(e);
  }
}

// extend FileReader
// https://stackoverflow.com/a/32665193/2001566
if (!FileReader.prototype.readAsBinaryString) {
  FileReader.prototype.readAsBinaryString = function (fileData) {
    let binary = '';
    const pt = this;
    const reader = new FileReader();
    reader.onload = function (e) {
      const bytes = new Uint8Array(reader.result);
      const length = bytes.byteLength;
      for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      //pt.result  - readonly so assign binary
      pt.content = binary;
      $(pt).trigger('onload');
    };
    reader.readAsArrayBuffer(fileData);
  };
}

export { handleUsersReportFileSelect, handleHRStaffingFileSelect, updateUsers, processUserAdds };
